import en from './en-US'
import fr from './fr-FR'

export default {
  'en-US': en,
  'fr-FR': fr
}
